import React from 'react'
import  './pageLoader.scss';
import { CircularProgress } from '@mui/material';

function PageLoader({ icon = false}) {
  return (
      <section className="page-loader">
      {!icon && <div className="loading-data">
        <CircularProgress />
      </div>}
      </section>
  )
}

export default PageLoader